/**
 * 模块名称: 短信日志=>详情页
 * @author liujingxue@372163.com
 */

import React, { useState, useEffect } from 'react'
import {
  Divider,
  message
} from 'antd'
import api from '@/api'
import { parseSearch, judgeCryptoParamsUrl } from '@/utils'

let tplIds

const Details = (props) => {
  const { history } = props
  const search = parseSearch(props.location.search)
  const [detailList, setDetailList] = useState([])
  const [list, setList] = useState({})
  const [cont, setCont] = useState('')

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      api.getLogSmsDetail({ id: search.id }, true).then(data => {
        tplIds = data.tplId
        if (search.msgId) {
          api.setMessageReaded({ ids: [search.msgId] })
        }
        setDetailList(data)
        let code = Object.values(JSON.parse(data.content))[0]
        api.getThirdPartySmsTpl({}, true).then(data => {
          if(data.list[tplIds]){
            setList(data.list[tplIds])
            let str = data.list[tplIds].content
            let content = str.replace(/\${code}/g, code)
            setCont(content)
          }
        })
      })
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.go(-2)
      }, 1000)
    }

  }, [])

  return (
    <>
      <div className="mail-detail">
        <h1>{list.option ? list.option : null}</h1>
        <div className="mail-title">
          <div className="mail-name">手机号码：{detailList.mobile}</div>
          <div className="mail-name">发送时间：{detailList.updateTime}</div>
        </div>
        <Divider />
        <div className="mail-content1">{cont}</div>
      </div>
    </>
  )
}

export default Details